'use client';

import * as Styled from './IconPlus.styled';

export const IconPlus = ({
  isExpanded = false,
  className = '',
}: {
  isExpanded: boolean;
  className?: string;
}) => {
  return (
    <Styled.Svg
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1333_13951)">
        <path
          d="M4.25 12.2861H20.75"
          stroke="#10100F"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Styled.AnimatedPath
          $isExpanded={isExpanded}
          d="M12.5 4.03613V20.5361"
          stroke="#10100F"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1333_13951">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5 0.286133)"
          />
        </clipPath>
      </defs>
    </Styled.Svg>
  );
};
